<template>
  <div class="home">
    <bank-menu @bank-click="handleBankClick" />
  </div>
</template>

<script>
import BankMenu from '@/components/BankMenu.vue'
import { mapActions } from 'vuex'
import { platformMap } from '@/config/tableColumns'

export default {
  name: 'Home',
  components: {
    BankMenu
  },
  methods: {
    ...mapActions(['setPlatform', 'setBankName']),
    handleBankClick(bank) {
      console.log('选择的银行信息：', bank)
      
      // 检查bank对象和platform值
      if (!bank || !bank.platform) {
        this.$message.error('无效的银行信息')
        return
      }
      
      // 存储platform到vuex
      this.setPlatform(bank.platform)
      this.setBankName(platformMap[bank.platform] || '未知平台')
      
      // 跳转到用户列表页面
      this.$router.push(`/user-list/${bank.platform}`)
    }
  }
}
</script>

<style scoped>
.home {
  padding: 20px;
}
</style>
